export default "__VITE_ASSET__CCQG3KZd__"